import i18next from 'i18next';
import ICU from 'i18next-icu';
import { initReactI18next } from 'react-i18next';
import catalog from './locales/de/console.json';
import chartCatalog from '../../../web/src/i18n/locales/de/charts.json';
import operationsCatalog from './locales/de/operations.json';
import tenantAiCatalog from './locales/de/tenant-ai.json';
import tenantBillingCatalog from './locales/de/tenant-billing.json';
import tenantCatalog from './locales/de/tenant.json';

/**
 * Translation layer of the console (REQ-05-018): source locale `de`, ICU
 * message syntax. Every display text comes from `locales/de/*.json` (the
 * tenant detail, its billing and the problems and log pages have their own files to keep each catalog small; the chart
 * texts come from the web app with its shared chart, ADR-031).
 */
export const SOURCE_LOCALE = 'de';

export const resources = { de: { common: { ...catalog, ...tenantCatalog, ...tenantAiCatalog, ...tenantBillingCatalog, ...operationsCatalog, charts: chartCatalog.charts } } } as const;

export function initI18n(): typeof i18next {
  if (!i18next.isInitialized) {
    void i18next
      .use(ICU)
      .use(initReactI18next)
      .init({
        lng: SOURCE_LOCALE,
        fallbackLng: SOURCE_LOCALE,
        defaultNS: 'common',
        ns: ['common'],
        resources,
        initAsync: false,
        interpolation: { escapeValue: false },
        returnNull: false,
        // Permission keys contain a colon (`console:read`); it is no namespace separator here.
        nsSeparator: false,
      });
  }
  return i18next;
}
